// ============= Imports =============
import React, { createContext, useContext } from 'react';
import { IS_SIGNALR_ENABLED } from './SignalR.constants';
import { createNoOpSignalRContextValue } from './SignalR.noOp';
import type { SignalRContextProps } from './SignalR.types';
import { useSignalRProvider } from './useSignalRProvider';

// ============= Context =============
const SignalRContext = createContext<SignalRContextProps | undefined>(undefined);

// ============= Hook =============
export const useSignalR = (): SignalRContextProps => {
  const context = useContext(SignalRContext);
  if (!context) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
};

// ============= Provider =============
export const SignalRProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const enabledValue = useSignalRProvider();
  const value = IS_SIGNALR_ENABLED
    ? enabledValue
    : createNoOpSignalRContextValue();

  if (!IS_SIGNALR_ENABLED) {
    console.log('⏸️ SignalR is disabled via VITE_ENABLE_SIGNALR');
  }

  return (
    <SignalRContext.Provider value={value}>{children}</SignalRContext.Provider>
  );
};
